import theme from '@theme-ui/preset-tailwind';

export const shadows = {
  ...(theme.shadows && theme.shadows),
};
